<div class="ui-stock-selector">
  <ui-select
    [label]="categoryLabel()"
    [value]="value().categoryId"
    [options]="categoryOptions()"
    [placeholder]="'Select ' + categoryLabel().toLowerCase()"
    (valueChange)="selectCategory($event)"
  ></ui-select>

  <ui-select
    [label]="productLabel()"
    [value]="value().productId"
    [options]="filteredProducts()"
    [disabled]="!value().categoryId"
    [placeholder]="'Select ' + productLabel().toLowerCase()"
    (valueChange)="selectProduct($event)"
  ></ui-select>

  @if (showVariant()) {
    @if (allowMultipleVariants()) {
      <ui-select
        [label]="variantLabel()"
        [multiple]="true"
        [closeOnSelect]="false"
        [values]="value().variantIds"
        [options]="filteredVariants()"
        [disabled]="!value().productId"
        [placeholder]="'Select ' + variantLabel().toLowerCase()"
        (valuesChange)="selectVariants($event)"
      ></ui-select>
    } @else {
      <ui-select
        [label]="variantLabel()"
        [value]="value().variantId"
        [options]="filteredVariants()"
        [disabled]="!value().productId"
        [placeholder]="'Select ' + variantLabel().toLowerCase()"
        (valueChange)="selectVariant($event)"
      ></ui-select>
    }
  }

  @if (showQuantity()) {
    <ui-form-field
      [label]="quantityLabel()"
      type="number"
      min="1"
      [required]="true"
      [value]="value().quantity === null ? '' : '' + value().quantity"
      [error]="quantityError()"
      (valueChange)="setQuantity($event)"
    ></ui-form-field>
  }
</div>
